import React, {useEffect} from "react";
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setLanguage} from "../app/reducers/language-slice";
import type {RootState} from "../app/store";

const ChooseLanguage = () => {
    const {t, i18n} = useTranslation();
    const languageDefaultValue = useSelector((state: RootState) => state.language.value);
    const dispatch = useDispatch()
    const language = {
        list: [
            {key: 'en', name: 'EN'},
            {key: 'ua', name: 'UA'}
        ],
        setLanguage: (param) => dispatch(setLanguage(param))
    }

    useEffect(() => {
        i18n.changeLanguage(languageDefaultValue)
    }, [languageDefaultValue])

    return (
        <ul className='language-block d-flex'>
            {language.list.map((item, i) => {
                return <li key={i}
                           className={languageDefaultValue === item.key ? 'active' : ''}>
                    <NavLink to={'?language=' + item.key}
                             onClick={() => language.setLanguage(item.key)}>
                        {t(item.name)}
                    </NavLink>
                </li>;
            })}
        </ul>
    );
};

export default ChooseLanguage;